import type { LanguageCode } from '@elfsight/configurator-contracts';
import { COUNTRIES, USA } from '../countries';
import { type Country } from '../types';

const getCountryByLocale = (language: LanguageCode) => {
  const locale = new Intl.Locale(language);

  if (locale.region) {
    return locale.region;
  }
  const maximized = locale.maximize();
  return maximized.region;
};

export function getDefaultCountry(
  widgetLanguage: LanguageCode = 'en-US',
  countries: Country[] = COUNTRIES
) {
  const countryCode =
    getCountryByLocale(widgetLanguage) ??
    getCountryByLocale(navigator.language) ??
    'US';
  const fallbackCountry = countryCode.toUpperCase();

  return countries.find((c) => c.countryCode === fallbackCountry) ?? USA;
}
